import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { TransactionDocuments } from '../../../../models/TransactionDocuments/transaction-documents.model';

export interface UploadTransactionDocumentRequest {
    engagementId: number;
    documentType: string;
    file: File;
    comment?: string;
}

export const UploadTransactionDocument = createAsyncThunk(
    'transactionDocuments/uploadTransactionDocument',
    async (params: UploadTransactionDocumentRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const formData = new FormData();
            formData.append('File', params.file);
            const temporaryFileResponse = await axios.post(
                `/api/temporaryfiles`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
            );

            if (temporaryFileResponse.status !== 200) {
                throw new Error('Failed to upload the document');
            }

            const response = await axios.post(
                `/api/Marketplace/Engagements/${params.engagementId}/TransactionDocuments/Versions`,
                {
                    documentType: params.documentType,
                    temporaryFileId: temporaryFileResponse.data.id,
                    comment: params.comment,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the document');
            }

            return response.data as TransactionDocuments;
        } catch (error) {
            createNotification('Could not upload the document.', 'error');
            throw error;
        }
    }
);
